import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Button, Card } from "../../Ui/index.jsx";
import { pickLoadingEmoji, pickLoadingLine } from "../../loadingLines.js";

// How long the first load may take before the page offers a retry. The session is kept: only a real 401 ends it.
const STUCK_AFTER_MS = 25000;

// The screen shown while the app loads: a pulsing emoji and a line picked by where you are going (see loadingLines.js).
// If it is still loading after STUCK_AFTER_MS it says so and offers Retry.
export function LoadingScreen({ onRetry }) {
  const [pick] = useState(() => ({ emoji: pickLoadingEmoji(), caption: pickLoadingLine(window.location.pathname) }));
  const [stuck, setStuck] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    setStuck(false);
    const timer = setTimeout(() => setStuck(true), STUCK_AFTER_MS);
    return () => clearTimeout(timer);
  }, [onRetry, attempt]);

  if (stuck) {
    return (
      <div className="Atg-Connection">
        <Card className="Atg-Connection__card">
          <AlertTriangle size={22} />
          <h2 className="ds-h3">Connection problem</h2>
          <p className="ds-muted">The intranet is taking longer than expected to load. Your session was not logged out.</p>
          <Button variant="primary" onClick={() => { setAttempt((n) => n + 1); onRetry(); }}>Retry</Button>
        </Card>
      </div>
    );
  }
  return (
    <div className="Atg-Loading">
      <div className="Atg-Loading__emoji" aria-hidden="true">{pick.emoji}</div>
      <span className="Atg-Loading__title">Loading…</span>
      <span className="Atg-Loading__caption">{pick.caption}</span>
    </div>
  );
}
